<template>
	<v-dialog  
	 	v-model="dialog"
	 	:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		width="800"
		height="1024"
		max-width="1024"
		scrollable
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<z-activator v-bind="attrs" v-model="dialog"
				:type="activatorType"
				:icon-name="activatorIcon"
				:title="activatorTitle"
				:disabled="disabled"
				:outlined="activatorOutlined"
				:tooltip-text="activatorTooltipText"
				:tooltip-disabled="activatorTooltipDisabled"
			></z-activator>
		</template>

		<v-card elevation="4">
			<!-- Ttoolbar -->
			<v-toolbar elevation="0" dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ $vuetify.lang.t('$vuetify.' + title) | capitalize }} {{ item.id }}</v-toolbar-title>
				
				<v-spacer></v-spacer>
				
				<v-btn icon @click="fullscreen = !fullscreen" >
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else>mdi-arrow-expand</v-icon>
				</v-btn>

				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>

				<template v-slot:extension>
					<!-- Tabs -->
					<v-tabs v-model="tab" align-with-title>
						<v-tabs-slider color="yellow"></v-tabs-slider>
						<v-tab v-for="item in tabs" :key="item">
							{{ item }}
						</v-tab>
					</v-tabs>

					<v-toolbar v-if="tab==1" dense color="primary" elevation="0">
						<z-field-search v-model="searchRoles"></z-field-search>
						<z-confirm-delete @ok="onRemoveRoles()" activator-type="button-icon" :disabled="roles.length==0"></z-confirm-delete>
						<z-roles @ok="onAddRoles($event)" activator-icon="mdi-plus" multiple :excluded="item.usersroles"></z-roles>
					</v-toolbar>

				</template>
			</v-toolbar>

			<v-card-text style="height: 380px;">
				<v-tabs-items v-model="tab">
					<v-tab-item>
						<v-card flat>
							<v-card-text>
								<v-row>
									<v-col cols="12">
										<v-text-field
											:label="$vuetify.lang.t('$vuetify.name') | capitalize"
											v-model="item.name"
											dense
											clearable
											hide-details="auto"
										></v-text-field>
									</v-col>

									<v-col cols="12" sm="6" md="6">
										<v-text-field
											:label="'зображення' | capitalize"
											v-model="item.image"
											dense
											clearable
											hide-details="auto"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-text-field
											:label="'шлях' | capitalize"
											v-model="item.path"
											dense
											clearable
											hide-details="auto"
										></v-text-field>
									</v-col>
									
									<v-col cols="12">
										<v-textarea
											v-model="item.description"
											:label="$vuetify.lang.t('$vuetify.comment') | capitalize"
											hint=""
											rows="2"
										></v-textarea>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<v-list dense>
							<v-list-item-group v-model="roles" multiple>
								<template v-for="(itm, index) in filteredRoles">
									<v-list-item >
											<template v-slot:default="{ active }">
												<v-list-item-action>
													<v-checkbox :input-value="active"></v-checkbox>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title v-text="itm.name"></v-list-item-title>
													<!-- <v-list-item-subtitle v-text="itm.description"></v-list-item-subtitle> -->
													<!-- <v-list-item-subtitle v-text="itm.type.name"></v-list-item-subtitle> -->
												</v-list-item-content>

												<v-list-item-action>
													<z-confirm-delete @ok="onRemoveRole(itm)"></z-confirm-delete>
												</v-list-item-action>
											</template>
									</v-list-item>
									<v-divider v-if="index < filteredRoles.length - 1" :key="index"></v-divider>
								</template>
							</v-list-item-group>
						</v-list>
					</v-tab-item>
				</v-tabs-items>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zActivator from '@/views/components/activator/activator'
import zFieldSearch from '@/views/components/field.search'
import zConfirmDelete from '@/views/components/confirm-delete'
import zRoles from '@/views/dictionaries/Roles'

export default {
	mixins: [mixin],
	components: {
		zActivator,
		zFieldSearch,
		zConfirmDelete,
		zRoles,
	},
	data: () => ({
		title: 'service',
		icon: 'mdi-dots-vertical-circle',

        tabs: ['Головна', 'Ролі'],

		roles: [],
		searchRoles: '',
	}),

	computed: {
		...mapGetters('Services', [ 'endpoint', 'item' ]),

		filteredRoles() {
			return this.item.roles.filter(item => {
				return item.id==this.searchRoles
					|| item.name.toLowerCase().includes(this.searchRoles.toLowerCase())
			})
		},
	},

	methods: {
		...mapActions('Services', [ 'setItem', 'setItems', 'createItem', 'updateItem', 'deleteItem' ]),

		onAddRoles (items) {
			this.addItems(this.item.roles, items)
		},

		onRemoveRole (item) {
			this.removeItem(this.item.roles, item)
		},

		onRemoveRoles() {
			this.removeItems(this.item.roles, this.filteredRoles, this.roles)
			this.roles = []
		},
	},
}
</script>